import { useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import {
  GenerateInviteRequest,
  GenerateInviteResponse,
  ShareApplicationPerson,
} from "@/types/ShareApplication";
import variables from "@/config/variables";

export const useUnlinkedAccount = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const generateInviteLink = async (
    financialApplicationId: string,
    person: ShareApplicationPerson
  ): Promise<GenerateInviteResponse> => {
    setIsGenerating(true);
    setError(null);

    try {
      const request: GenerateInviteRequest = {
        emailAddress: person.emailAddress,
        auth0ConsumerOrganizationId: variables.consumerAuth0OrgId,
        role: person.role,
        keyPersonOrJointOwnerId: person.keyPersonOrJointOwnerId,
      };

      const response = await financialApplicationApiClient.generateInviteLink(
        financialApplicationId,
        request
      );
      return response;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to generate invite link";
      setError(errorMessage);
      throw err;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateInviteLink,
    isGenerating,
    error,
  };
};
